import { __awaiter } from "tslib";
import Compressor from 'compressorjs';
import ImageToBlob from 'image-to-blob';
import { Storage } from 'aws-amplify';
import { reject } from './response';
let functions = {
    upload(name, file) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = yield Storage.put(name, file);
            return result;
        });
    },
    getImage(fileName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let path = yield Storage.get(fileName);
                return path;
            }
            catch (error) {
                throw reject(error);
            }
        });
    },
    getImageBlob(fileName) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            let file = yield functions.getImage(fileName);
            ImageToBlob(file, (err, blob) => {
                if (err) {
                    return reject(err);
                }
                resolve(blob);
            });
        }));
    },
    uploadImage(options) {
        return new Promise((resolve, reject) => {
            // tslint:disable-next-line:no-unused-expression
            new Compressor(options.file, {
                width: options.width,
                height: options.height,
                quality: options.quality,
                success(image) {
                    return __awaiter(this, void 0, void 0, function* () {
                        try {
                            let result = yield Storage.put(options.name, image, {
                                acl: 'public-read'
                            });
                            resolve(result);
                        }
                        catch (error) {
                            reject(error);
                        }
                    });
                },
                error(err) {
                    reject(err);
                }
            });
        });
    }
};
export default functions;
